import { createSlice } from '@reduxjs/toolkit';
import { migrateFavoriteKeys } from '../../utils/favoriteKeys';

const STORAGE_KEY = 'fleaFavorites';

const loadFavorites = () => {
  if (typeof window === 'undefined') return [];
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    const parsed = stored ? JSON.parse(stored) : [];
    return migrateFavoriteKeys(Array.isArray(parsed) ? parsed : []);
  } catch (error) {
    console.error('Failed to load favorites from storage:', error);
    return [];
  }
};

const saveFavorites = (favorites) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
  } catch (error) {
    console.error('Failed to save favorites to storage:', error);
  }
};

const initialState = {
  favoriteItems: loadFavorites(),
};

const favoritesSlice = createSlice({
  name: 'favorites',
  initialState,
  reducers: {
    toggleFavorite: (state, action) => {
      const key = String(action.payload);
      const index = state.favoriteItems.indexOf(key);

      if (index > -1) {
        state.favoriteItems.splice(index, 1);
      } else {
        state.favoriteItems.push(key);
      }
      saveFavorites(state.favoriteItems);
    },
    clearFavorites: (state) => {
      state.favoriteItems = [];
      saveFavorites(state.favoriteItems);
    },
  },
});

export const { toggleFavorite, clearFavorites } = favoritesSlice.actions;
export default favoritesSlice.reducer;

